// extracted by mini-css-extract-plugin
module.exports = {"component":"AreaBadge_component__3VAR9","isActive":"AreaBadge_isActive__CUcEZ"};